<template>
    <section>
      <!-- start of sidebar -->
      <v-navigation-drawer
        v-model="drawer"
        :clipped="$vuetify.breakpoint.lgAndUp"
        app
      >
        <v-list dense>
          <template v-for="item in items">
            <v-row v-if="item.heading" :key="item.heading" align="center">
              <v-col cols="6">
                <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
              </v-col>
              <v-col cols="6" class="text-center">
                <a href="#!" class="body-2 black--text">EDIT</a>
              </v-col>
            </v-row>
            <v-list-group
              v-else-if="item.children"
              :key="item.text"
              v-model="item.model"
              :prepend-icon="item.model ? item.icon : item['icon-alt']"
              append-icon
            >
              <template v-slot:activator>
                <v-list-item :to="item.link">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-list-item
                v-for="(child, i) in item.children"
                :key="i"
                :to="child.link"
              >
                <v-list-item-action v-if="child.icon">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ child.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item v-else :key="item.text" :to="item.link">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-navigation-drawer>
      <!-- end of sidebar -->
  
      <!-- start of appbar -->
      <v-app-bar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        app
        color="light-blue accent-3"
        dark
      >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
        <v-toolbar-title  class="ml-0 pl-4">
          <span class="hidden-sm-and-down">{{storeName}}</span>
        </v-toolbar-title>
        <v-spacer />
       <span> {{userName}}</span>
        <v-btn icon>
          <v-icon>mdi-apps</v-icon>
        </v-btn>
        <v-btn icon>
          <v-icon>mdi-bell</v-icon>
        </v-btn>
        <v-btn text color="white" @click="logout">Logout</v-btn>
      </v-app-bar>
      <!-- end of appbar -->
    </section>
  </template>
  
  <script>
  export default {
    computed: {
      items() {
        return this.myitems;
      },
      userName() {
      return localStorage.getItem("userName");
    },
      storeName() {
      return localStorage.getItem("storeName");
    },
    },
    data: () => ({
      drawer: true,
      myitems: [
        { icon: "mdi-contacts", text: "Create Order", link: "/customer/order", role: 1 },
        {
          icon: "mdi-keyboard",
          text: "Pending Orders",
          link: "/pending/orders",
          role: 1
        },
        {
          icon: "mdi-keyboard",
          text: "Delivered Orders",
          role: 1
        }
      ],
    }),
    methods: {
      logout() {
        localStorage.removeItem("token");
        this.$router.push("/login");
      },
    },
  };
  </script>
  
  <style scoped>
  /* .v-list-item {
    padding: 0px 0px 5px 10px !important;
  } */
  </style>
  
  